/* eslint-disable no-bitwise */
import { UntypedFormGroup } from "@angular/forms";
import { Cellstyle } from "~app/common/components/hot-doc/hotdoc/cell";
import { HotDoc, IHotColumnDefinition } from "~app/common/components/hot-doc/hotdoc/doc";
import { HotRow } from "~app/common/components/hot-doc/hotdoc/row";
import { RaskModalService } from "~app/common/components/modal/rask-modal.service";
import { ProduktmatrisGrid } from "../../produktinstruktioner-details/matris/ProduktmatrisGrid";
import { StolpCell } from "../../produktinstruktioner-details/matris/cells/stolpCell";
import { ILangdklass } from "../IProduktdefinition";
import { ProduktdefinitionHeaderData } from "./../ProduktdefinitionHeaderData";
import { BaseMatrix } from "./BaseMatrix";
import { LangdDiameterMatris } from "./LangdDiameterMatris";

export class Stolpmatris extends LangdDiameterMatris {

    constructor(grid: ProduktmatrisGrid,
        form: UntypedFormGroup,
        headerData: ProduktdefinitionHeaderData,
        canEdit: boolean) {
        super(grid, form, headerData, canEdit);
    }

    getStolp(raskModalService: RaskModalService, form: UntypedFormGroup): HotDoc {
        const colFactory = () => this.buildStolpColumnDefinitions({ readOnly: !this.canEdit,
            type: "numeric" });
        const rowFactory = (doc: HotDoc) => this.buildStolpRowDefinitions(doc, raskModalService);
        const settingsFactory = (doc: HotDoc) => this.getBaseSettings(doc, raskModalService);

        return new HotDoc(colFactory, rowFactory, settingsFactory);
    }

    private buildStolpRow(doc: HotDoc, langdklass: ILangdklass, row: HotRow, raskModalService: RaskModalService) {
        if (this.canEdit) {
            row.add(BaseMatrix.settingsCellName, this.getEditLangdklassCell(doc, langdklass, raskModalService));
        }

        row.add(BaseMatrix.rowHeaderCellName, this.getLangdklassHeaderCell(langdklass));
        row.add("undre", new StolpCell(langdklass,
            this.form,
            langdklass.stolpMinRotdiameter,
            Cellstyle.Default | Cellstyle.AlignCenter,
            newVal => langdklass.stolpMinRotdiameter = newVal.newValue));
        row.add("ovre", new StolpCell(langdklass,
            this.form,
            langdklass.stolpMaxRotdiameter,
            Cellstyle.Default | Cellstyle.AlignCenter,
            newVal => langdklass.stolpMaxRotdiameter = newVal.newValue));
    }

    private readonly buildStolpColumnDefinitions = (editableCollSettings: { readOnly: boolean; type: string; editor?: boolean }): IHotColumnDefinition[] => {
        const columns: IHotColumnDefinition[] = [];
        this.addEditColumn(columns, false);

        columns.push({
            header: "Längdklass",
            width: 70,
            readOnly: true,
            cellName: BaseMatrix.rowHeaderCellName
        });

        columns.push({
            header: "<span>Undre gräns</span>",
            cellName: "undre",
            type: editableCollSettings.type,
            readOnly: editableCollSettings.readOnly,
            editor: editableCollSettings.editor
        });

        columns.push({
            header: "<span>Övre gräns</span>",
            cellName: "ovre",
            type: editableCollSettings.type,
            readOnly: editableCollSettings.readOnly,
            editor: editableCollSettings.editor
        });

        return columns;
    };

    private readonly buildStolpRowDefinitions = (doc: HotDoc, raskModalService: RaskModalService): void => {
        this.grid.langdklasser.forEach((langdklass) => {
            doc.createRow((row) => this.buildStolpRow(doc, langdklass, row, raskModalService));
        });
    };

}
